export const login = {
  page: {
    invalidCredentialsMessage: 'Either the email or password entered is incorrect. Please try again',
    inactiveTimeoutTitle: 'Inactive Timeout',
    inactiveTimeoutDescription: 'You have been logged out due to inactivity',
    pinFieldLabel: 'Enter your 6 digit PIN',
    forgotPinMessage: 'Forgot PIN? Please contact support in our Slack channel.',
    useEmailAndPasswordLabel: 'Use email and password instead',
    emailLabel: 'Email ',
    passwordLabel: 'Password',
    loginLabel: 'Login',
    forgotPasswordLink: 'Forgot Password?'
  },
  twoFactor: {
    unableToUse2faMessage: 'Unable to use 2FA',
    invalidLoginTitle: 'Invalid login',
    invalidLoginMessage: 'Login could not be validated.',
    invalidCodeTitle: 'Invalid Code',
    invalidCodeMessage: 'This code is invalid or has expired. Click Cancel and restart the login process.',
    unknownErrorTitle: 'Unknown error',
    unknownErrorMessage: 'Unknown error',
    title: 'Two-Factor Authentication',
    instructions:
      "We've sent a one-time code to the device associated with your account. Please enter the code below to proceed with the login.",
    otpFieldLabel: 'One-Time Code',
    rememberDeviceLabel: 'Remember this device',
    continueButtonLabel: 'Continue Login',
    cancelLabel: 'Cancel'
  },
  forgotPassword: {
    genericErrorMessage: 'Unable to complete the operation',
    invalidEmailMessage: 'Invalid Email Address',
    successDialogTitle: 'Success',
    title: 'Forgot Password?',
    instructions: 'Enter the email address connected to your Truentity Health account and a link will be sent to reset your password.',
    emailLabel: 'Email',
    submitButtonLabel: 'Reset Password'
  }
} as const;
